<template>
  <ReachDecimalInput
      ref="input"
      :formField="validatedField"
      :field-config="fieldConfig"
      :read-only="readOnly"
      :editor-mode="editorMode"
      :label="fieldConfig.fieldLabel"
      :hint="fieldConfig.shortHelpText"
      :help-title="fieldConfig.helpWindowTitle"
      :help-message="fieldConfig.htmlHelpText"
      :initialFocus="fieldConfig.autofocus"
      :min="fieldConfig.min"
      :max="fieldConfig.max"
      :step="fieldConfig.step"
      :round-to="fieldConfig.roundTo"
      :placeholder="fieldConfig.formPlaceholder"
      :allow-null="fieldConfig.allowNull"
      :data-type="fieldConfig.dataType"
      :round-method="fieldConfig.roundMethod"
      :grid-editor="gridEditor"
      :open-from-grid="openFromGrid"
  >
  </ReachDecimalInput>
</template>

<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import ReachDecimalInput from "@/components/inputs/ReachDecimalInput";
import DecimalFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/DecimalFormFieldConfig";


export default {
  name: "DecimalRenderer",
  components: {ReachDecimalInput},

  mounted(){
    // this.$refs.input.format = (val) => { return RtModule().get(this.fieldConfig.toStringFunction).call(this.validatedField, val,
    //     this.fieldConfig, this.validatedField.getFormConfig());
    // }
  },

  props:{
    validatedField: { type: FormValidatedField, required:true },
    fieldConfig: { type: DecimalFormFieldConfig, required:true },
    openFromGrid: {default: false},
    gridEditor: {default: null},
  },

  methods:{
    setReadOnly(readOnly){
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },
    setEditorMode(val){
      this.editorMode = val;
    },
  },

  data: () => ({
    readOnly: true,
    editorMode: false,
  })
}
</script>

